import type { SxProps, Theme } from '@mui/material/styles';

export const tableContainerSx: SxProps<Theme> = {
  pb: '24px',
  width: '100%',
  height: 'fit-content'
};

export const tableSx: SxProps<Theme> = {
  '& tr > :is(td, th):last-child': { pr: 2 }
};

export const tableHeadRowSx: SxProps<Theme> = theme => ({
  '& td, & th': {
    pb: 1,
    borderBottom: `0.5px solid ${theme.palette.text.primary}`,
    backgroundColor: 'background.paper'
  }
});

export const sectionHeaderRowSx: SxProps<Theme> = {
  '&:first-of-type td, &:first-of-type th': { pt: 1 }
};

export const sectionNameCellSx: SxProps<Theme> = { fontWeight: 700 };

export const shortTitleCellSx: SxProps<Theme> = { width: '33%' };

export const dataRowSx: SxProps<Theme> = {
  '&:last-child td, &:last-child th': { pb: 1 },
  '&:first-of-type td, &:first-of-type th': { pt: 1 }
};
